<template>
    <div>
        <slot :attrs="atributos[forma.tipo - 1]" :accion="accion" />

        <v-dialog v-model="dialog" eager scrollable max-width="1300px">
            <v-card class="mx-auto" min-width="80%" outlined>
                <iframe
                    id="fred"
                    title="PDF in an i-Frame"
                    :src="archivoPdfUrl"
                    frameborder="1"
                    scrolling="auto"
                    height="800"
                    allow="fullscreen"
                ></iframe>
                <v-card-text v-if="forma.id === 41" class="pb-4">
                    <div class="text-body-2 text-text">
                        {{ $t("formaDinamica.nota-alimentos.1") }}
                    </div>
                    <ol class="ml-4">
                        <li>{{ $t("formaDinamica.nota-alimentos.2") }}</li>
                        <li>{{ $t("formaDinamica.nota-alimentos.3") }}</li>
                        <li>{{ $t("formaDinamica.nota-alimentos.4") }}</li>
                        <li>{{ $t("formaDinamica.nota-alimentos.5") }}</li>
                    </ol>
                </v-card-text>
                <v-card-actions class="d-flex flex-row justify-center">
                    <v-btn
                        variant="outlined"
                        color="primary"
                        @click="dialog = false"
                    >
                        {{ $t("boton-cerrar") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useAttrs } from "vue";
import axios from "axios";
import { router } from "@inertiajs/vue3";

const props = defineProps({
    forma: Object,
    stand: Object,
    user: Object,
    origen: String,
});

const dialog = ref(false);
const archivoPdfUrl = ref(null);
const disabled = ref(false);

const revisarDisabled = () => {
    if (props.user && props.forma.clave == "E6") {
        if (props.user.roles[0].name == "expositor") {
            return false;
        } else if (props.user.roles[0].name == "coordinador") {
            return false;
        }
    }
    return false;
};

const atributos = computed(() => [
    { link: true },

    { link: true, href: props.forma.url_pagina_web, target: "_blank" },
    {
        href: route(props.forma.url_formulario, {
            stand: props.stand.id,
            forma: props.forma.parametros,
        }),
        disabled: revisarDisabled(),
    },

    { disabled: true },
]);

onMounted(() => {
    disabled.value = revisarDisabled();
});

const accion = (event) => {
    // Registrar click en la bitácora
    axios.post(
        route("bitacora.registrar", {
            origen: props.origen,
            forma_id: props.forma.id,
        })
    );

    // Mostar PDF
    if (props.forma.tipo == 1) {
        axios
            .get(
                route("stand-archivo.url", {
                    archivo: props.forma.archivo_pdf,
                })
            )
            .then((response) => {
                archivoPdfUrl.value = response.data;
                dialog.value = true;
            });
    }

    // Redireccionar a Pagina Externa
    if (props.forma.tipo == 2) console.log("Página Externa");

    // Redirigir a Formulario
    if (props.forma.tipo == 3) {
        event.preventDefault();
        if (disabled.value) return;

        router.get(
            route(props.forma.url_formulario, {
                stand: props.stand.id,
                forma: props.forma.parametros,
            }),
            {},
            {
                preserveState: false,
            }
        );
    }

    if (props.forma.tipo == 4) console.log("Por Definir");
};
</script>
